import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IInventoryVendorListResponse, IInventoryVendorListResponseData } from "@/api_framework/api_modals/Inventory";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useInventoryVendorListSearchAPI = () => {
  const [searchResults, setSearchResults] = useState<IInventoryVendorListResponseData[]>([]);
  const dispatch = useAppDispatch();
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const clearSearchResults = () => {
    setSearchResults([]);
  };

  const execute = useCallback(async (searchID: string, triggerPage?: string) => {
    dispatch(
      setLoading({
        key: "isInventoryVendorListLoadingInProgess",
        status: true,
      }),
    );

    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      const params = new URLSearchParams({ search: searchID });
      if (triggerPage === "PO_PAGE_SEARCH") {
        params.append("trigger_page", "PO_PAGE_SEARCH");
      }
      const response: IInventoryVendorListResponseData = await axios
        .get(`${INVENTORY_MODULE?.PURCHASE_ORDER_VENDOR_SEARCH?.baseURL}?${params.toString()}`, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IInventoryVendorListResponse>) => {
          dispatch(
            setLoading({
              key: "isInventoryVendorListLoadingInProgess",
              status: false,
            }),
          );
          if (res.data.status === true) {
            setSearchResults(res.data.data);
            return res.data.data;
          } else {
            setSearchResults([]);
            return null;
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
          setSearchResults([]);
          dispatch(
            setLoading({
              key: "isInventoryVendorListLoadingInProgess",
              status: false,
            }),
          );

          captureError(e);
          return null;
        });
      return response;
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
      return null;
    }
  }, []);
  return { searchResults, execute, clearSearchResults };
};
